import { COLOR_THRESHOLDS } from "modules/DealerReports/util/parser";

export const isDurationField = (key: string) => /(duration|time)/.test(key.toLowerCase());

export const isPercentageField = (key: string) => /(percent|percentage)/.test(key.toLowerCase());

export const formatPercent = (value: unknown): string => {
  const percent = value ?? 0;
  return typeof percent === "string" && percent.endsWith("%") ? percent : `${String(percent)}%`;
};

export const getColor = (value: number, type: keyof typeof COLOR_THRESHOLDS): string => {
  const threshold = COLOR_THRESHOLDS[type].find(t => value >= t.min && value <= t.max);
  return threshold?.color || "";
};

export const formatDuration = (seconds: number): string => {
  const milliseconds = seconds * 1000;

  const hours = Math.floor(milliseconds / (1000 * 60 * 60));
  const minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60));
  const secs = Math.floor((milliseconds % (1000 * 60)) / 1000);

  return [hours.toString().padStart(2, "0"), minutes.toString().padStart(2, "0"), secs.toString().padStart(2, "0")].join(":");
};

export const calculatePercentage = (value: number, total: number): number => {
  return total === 0 ? 0 : Math.round((value / total) * 100 * 100) / 100;
};

export const formatValueWithPercentage = (value: number, percentage: number): string => {
  return `${value || 0} (${percentage || 0}%)`;
};

export const getNumericValue = (field: any): number => {
  if (typeof field === "number") return field;
  if (typeof field === "object" && field?.value !== undefined) return field.value;
  if (typeof field === "string" && !isNaN(Number(field))) return Number(field);
  return 0;
};
